import { useCurrentUser as useCurrentUserFromCroods } from 'croods-auth'
import useCroodsAuthStorage from './useCroodsAuthStorage'

const useCurrentUser = props => {
  const authStorage = useCroodsAuthStorage()
  const currentUserInfo = useCurrentUserFromCroods({ ...authStorage, ...props })
  return currentUserInfo
}

export default useCurrentUser
